import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { X, ChevronLeft, ChevronRight } from 'lucide-react';

const vacatureSlides = [
  { src: '/vacature1.webp', alt: 'Finance Lead', email: 'hrm@prosafefireprotection.com' },
  { src: '/vacature2.webp', alt: 'Technicien Brandpreventie', email: 'hrm@prosafefireprotection.com' },
  { src: '/vacature3.webp', alt: 'Technician Fire Protection', email: 'hrm@prosafefireprotection.com' }
];

const VacancyPopup = () => {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const dismissed = sessionStorage.getItem('vacancyPopupDismissed');
    if (!dismissed) {
      const timer = setTimeout(() => setIsOpen(true), 1500);
      return () => clearTimeout(timer);
    }
  }, []);

  useEffect(() => {
    if (!isOpen) return;
    const interval = setInterval(() => {
      setCurrentSlide(prev => (prev + 1) % vacatureSlides.length);
    }, 10000);
    return () => clearInterval(interval);
  }, [isOpen]);

  const close = useCallback(() => {
    setIsOpen(false);
    sessionStorage.setItem('vacancyPopupDismissed', 'true');
  }, []);

  const prev = () => setCurrentSlide(p => (p - 1 + vacatureSlides.length) % vacatureSlides.length);
  const next = () => setCurrentSlide(p => (p + 1) % vacatureSlides.length);

  const goToContact = () => {
    close();
    navigate('/vacatures');
    setTimeout(() => {
      document.getElementById('vacatures-contact-form')?.scrollIntoView({ behavior: 'smooth' });
    }, 300);
  };

  if (!isOpen) return null;

  return (
    <div 
      className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/60 backdrop-blur-sm p-4"
      onClick={close}
      data-testid="vacancy-popup-overlay"
    >
      <div 
        className="relative bg-white rounded-lg shadow-2xl w-full max-w-[1000px] max-h-[90vh] overflow-hidden"
        onClick={e => e.stopPropagation()}
        data-testid="vacancy-popup"
      >
        {/* Close button */}
        <button
          onClick={close}
          className="absolute top-3 right-3 z-50 bg-black/70 hover:bg-black text-white rounded-full p-2 transition-colors"
          data-testid="vacancy-popup-close"
        >
          <X size={20} />
        </button>

        {/* Image container */}
        <div className="relative overflow-auto rounded-t-lg cursor-pointer" style={{ maxHeight: 'calc(90vh - 56px)' }} onClick={goToContact}>
          <img
            src={vacatureSlides[currentSlide].src}
            alt={vacatureSlides[currentSlide].alt}
            className="w-[1000px] h-auto block"
            data-testid="vacancy-popup-image"
          />

          {/* Left arrow */}
          <button
            onClick={prev}
            className="absolute left-3 top-1/2 -translate-y-1/2 bg-black/60 hover:bg-black/80 text-white rounded-full p-2 transition-colors"
            data-testid="vacancy-popup-prev"
          >
            <ChevronLeft size={24} />
          </button>

          {/* Right arrow */}
          <button
            onClick={next}
            className="absolute right-3 top-1/2 -translate-y-1/2 bg-black/60 hover:bg-black/80 text-white rounded-full p-2 transition-colors"
            data-testid="vacancy-popup-next"
          >
            <ChevronRight size={24} />
          </button>

          {/* Dots indicator */}
          <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex gap-2">
            {vacatureSlides.map((_, idx) => (
              <button
                key={idx}
                onClick={() => setCurrentSlide(idx)}
                className={`w-3 h-3 rounded-full transition-colors ${
                  idx === currentSlide ? 'bg-[#e21b1b]' : 'bg-white/70'
                }`}
                data-testid={`vacancy-popup-dot-${idx}`}
              />
            ))}
          </div>
        </div>

        {/* Email footer */}
        <div className="p-4 text-center bg-[#1a1a1a] rounded-b-lg">
          <a
            href={`mailto:${vacatureSlides[currentSlide].email}`}
            className="font-montserrat font-bold text-white hover:text-[#e21b1b] transition-colors text-base"
            data-testid="vacancy-popup-email"
          >
            {vacatureSlides[currentSlide].email}
          </a>
        </div>
      </div>
    </div>
  );
};

export default VacancyPopup;
